import { render, staticRenderFns } from "./AdminServicesPage.vue?vue&type=template&id=01c28632&scoped=true&"
import script from "./AdminServicesPage.vue?vue&type=script&lang=js&"
export * from "./AdminServicesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c28632",
  null
  
)

export default component.exports